import "@/App.css";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import AWSCourseSection from "./components/AWSCourseSection";
import CombinedAWSSection from "./components/CombinedAWSSection";
import AzureCourseSection from "./components/AzureCourseSection";
import OCICourseSection from "./components/OCICourseSection";
import WhyNowSection from "./components/WhyNowSection";
import InstructorSection from "./components/InstructorSection";
import FAQSection from "./components/FAQSection";
import EnrollSection from "./components/EnrollSection";
import Chatbot from "./components/Chatbot";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="min-h-screen bg-[#0A0A0F]">
      <Header />
      <main>
        <HeroSection />
        <AWSCourseSection />
        <CombinedAWSSection />
        <AzureCourseSection />
        <OCICourseSection />
        <WhyNowSection />
        <InstructorSection />
        <FAQSection />
        <EnrollSection />
      </main>
      <Footer />
      <Chatbot />
    </div>
  );
}

export default App;
